import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import tr from './tr.json';
import en from './en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: tr },
      en: { translation: en },
    },
    fallbackLng: 'tr',
    supportedLngs: ['tr', 'en'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'vokelle_lang',
      caches: ['localStorage'],
    },
  });

// <html lang> her zaman aktif dile eşit olsun — CSS text-transform:uppercase
// İngilizce metinde "I"yı Türkçe kuralıyla "İ" yapmasın (ör. "SECURITY").
function syncHtmlLang(lng) {
  const l = (lng || 'tr').split('-')[0];
  if (typeof document !== 'undefined') document.documentElement.lang = l === 'en' ? 'en' : 'tr';
}
syncHtmlLang(i18n.resolvedLanguage || i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
